import Bouchers from "./Bouchers";
import HeroPortfolio from "./HeroPortfolio";
import Instagram from "./Instagram";

import LogoDesignGridSection from "./LogoDesignGridSection";
import LogoDesignGridSection2 from "./LogoDesignGridSection2";
import LogoDesignSection from "./LogoDesignSection";
import NewPortfolioSocial from "./NewPortfolioSocial";
import NewPortfolioSoft from "./NewPortfolioSoft";

import SocialMediaGrowthSection from "./SocialMediaGrowthSection";
import WebSection from "./WebSection";
import Youtube from "./Youtube";

const NewPortfolio = () => {
  return (
    <div>
      <section id="hero-portfolio">
        <HeroPortfolio />
      </section>

      {/* Tab Navigation */}
        <LogoDesignSection />

      {/* Sections with IDs for smooth scroll */}
      <section id="logo-design">
        <LogoDesignGridSection />
      </section>

      <section id="logo-design-2">
        <LogoDesignGridSection2 />
      </section>

      <section id="social-media-design">
        <NewPortfolioSocial />
      </section>

      <section id="soft-section">
        <NewPortfolioSoft />
      </section>

      <section id="website-section">
        <WebSection />
      </section>
      <section id="brochures-section">
        <Bouchers />
      </section>

      <section id="social-media-growth">
        <SocialMediaGrowthSection />
      </section>

      <Instagram />

      <section id="youtube-section">
        <Youtube />
      </section>
    </div>
  );
};

export default NewPortfolio;
